























import Vue from 'vue';
import { mapGetters } from 'vuex';
import { DoorConfiguration } from '../../../configurator/DoorConfiguration';

export default Vue.extend({
    name: 'RDoorLeafSurface',
    computed: {
    ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration']),
        currentDoorConfiguration() {
            return this.getCurrentDoorConfiguration.Get(DoorConfiguration.DoorLeafSurface);
        }
    },
    methods: {
        
    },
    mounted() {
        
    }
})
